const empty = '..........';

const titluImplicit = 'Heart clinic - buletin ecografie ';
const inputIndexareBSA = [
	'DTDVS',
	'DTSVS',
	'VTDVS',
	'VTSVS',
	'Ao.inel.',
	'AoAsc.',
	'BulbAo.',
	'Vol.AS',
];
const inputValoriDeVerificat = {
	'DTDVS':{
		claseM: {
			58:'normal',
			63: 'mild',
			68: 'moderate',
			69: 'severe'
		},
		claseF: {
			52:'normal',
			57: 'mild',
			61: 'moderate',
			62: 'severe'
		},
	},
	'DTDVSbsa':{
		claseM: {
			30:'normal',
			33: 'mild',
			36: 'moderate',
			37: 'severe'
		},
		claseF: {
			32:'normal',
			35: 'mild',
			37: 'moderate',
			38: 'severe'
		},
	},
	'DTSVS':{
		claseM: {
			41:'normal',
			44: 'mild',
			45: 'moderate',
			46: 'severe'
		},
		claseF: {
			36:'normal',
			39: 'mild',
			41: 'moderate',
			42: 'severe'
		},
	},
	'DTSVSbsa':{
		claseM: {
			22:'normal',
			24: 'mild',
			25: 'moderate',
			26: 'severe'
		},
		claseF: {
			22:'normal',
			24: 'mild',
			26: 'moderate',
			27: 'severe'
		},
	},
	'VTDVS':{
		claseM: {
			151:'normal',
			175: 'mild',
			200: 'moderate',
			201: 'severe'
		},
		claseF: {
			107:'normal',
			121: 'mild',
			130: 'moderate',
			131: 'severe'
		},
	},
	'VTDVSbsa':{
		claseM: {
			75:'normal',
			90: 'mild',
			100: 'moderate',
			101: 'severe'
		},
		claseF: {
			62:'normal',
			71: 'mild',
			80: 'moderate',
			81: 'severe'
		},
	},
	'VTSVS':{
		claseM: {
			62:'normal',
			74: 'mild',
			85: 'moderate',
			86: 'severe'
		},
		claseF: {
			43:'normal',
			56: 'mild',
			67: 'moderate',
			68: 'severe'
		},
	},
	'VTSVSbsa':{
		claseM: {
			32:'normal',
			39: 'mild',
			45: 'moderate',
			46: 'severe'
		},
		claseF: {
			25:'normal',
			33: 'mild',
			40: 'moderate',
			41: 'severe'
		},
	},
	'Ao.inel.': {
		claseM: {
			31:'normal',
			32: 'severe'
		},
		claseF: {
			26:'normal',
			27: 'severe'
		},
	},
	'Ao.inel.bsa':{
		claseM: {
			16:'normal',
			17: 'severe'
		},
		claseF: {
			16:'normal',
			17: 'severe'
		},
	},
	'AoAsc.':{
		claseM: {
			36:'normal',
			37: 'severe'
		},
		claseF: {
			32:'normal',
			33: 'severe'
		},
	},
	'AoAsc.bsa':{
		claseM: {
			19:'normal',
			20: 'severe'
		},
		claseF: {
			19:'normal',
			20: 'severe'
		},
	},
	'BulbAo.':{
		claseM: {
			40:'normal',
			41: 'severe'
		},
		claseF: {
			36:'normal',
			37: 'severe'
		},
	},
	'BulbAo.bsa':{
		claseM: {
			21:'normal',
			22: 'severe'
		},
		claseF: {
			21:'normal',
			22: 'severe'
		},
	},	
	'Vol.ASbsa':{
		claseM: {
			35:'normal',
			42: 'mild',
			48: 'moderate',
			49: 'severe'
		},
		claseF: {
			35:'normal',
			42: 'mild',
			48: 'moderate',
			49: 'severe'
		},
	},
	'MasaVS':{
		claseM: {
			115:'normal',
			116: 'severe'
		},
		claseF: {
			95:'normal',
			96: 'severe'
		},
	},
	'RTW':{
		claseM: {
			0.42:'normal',
			0.43: 'severe'
		},
		claseF: {
			0.42:'normal',
			0.43: 'severe'
		},
	}
};

const observatii = [
'<b>VS</b> <b>ne</b>dilatat, <b>ne</b>hipertrofiat, cu functie sistolica globala si segmentara prezervata',
'<b>VS</b> <b>ne</b>dilatat, hipertrofiat concentric, cu functie sistolica globala si segmentara prezervata',
'<b>VS</b> dilatat, cu functie sistolica globala redusa prin ',
'<b>Cavitati drepte <b>nedilatate</b>',
'<b>Cavitati cu <b>dimensiuni normale</b>',
'<b>Presiuni</b> de umplere VS <b>normale</b>',
'<b>Presiuni</b> de umplere VS <b>crescute</b>',
'<b>Disfunctie</b> diastolica tip relaxare intarziata',
'<b>Dilatare</b> biatriala',
'Dilatare <b>AS</b>',
'Ectazie de <b>aorta ascendenta</b>',
'Ectazie <b>anulo-aortica</b>',
'<b>Ao</b> ascendenta cu pereti ateromatosi',
'<b>Valva</b> aortica <b>bicuspa</b>',
'<b>Valva</b> aortica <b>tricuspa</b>',
'<b>Calcificare</b> inel mitral posterior',
'<b>Valva</b> aortica tricuspa, cu calcificari, ce realizeaza:',
'<b>Regurgitare</b> mitrala <b>usoara degenerativa</b>',
'<b>Regurgitare</b> mitrala <b>moderata degenerativa</b>',
'<b>Valva</b> mitrala cu <b>modificari degenerative, ce realizeaza o boala valvulara mitrala',
'<b>Regurgitare</b> tricuspidiana moderata',
'<b>Hipertensiune</b> pulmonara cu probabilitate <b>scazuta</b>',
'<b>Hipertensiune</b> pulmonara cu probabilitate <b>intermediara</b>',
'<b>Hipertensiune</b> pulmonara cu probabilitate <b>inalta</b>',
'<b>SIA, SIV</b> integre',
'<b>Cavitati</b> libere',
'Pericard fara lichid',
'Grasime epicardica prezenta',
'<b>Sonda</b> de stimulare prezenta in cavitatile drepte',
'<b>Proteza</b> valculara mecanica in pozitie <b>aortica</b> cu clicuri de inchidere si deschidere bine vizibile, normofunctionala',
'<b>Proteza</b> valculara mecanica in pozitie <b>mitrala</b> cu clicuri de inchidere si deschidere bine vizibile, normofunctionala'

];

// Export for ES modules
export { empty, titluImplicit, inputIndexareBSA, inputValoriDeVerificat, observatii };